import { createClient } from "@supabase/supabase-js";
import {
  AuthService,
  ProjectService,
  DocumentService,
  NotionService,
  UserService,
  RoomService,
  ChatService,
  SlackService,
  DiscordService,
  ProjectSettingsService,
  MCPConnectionService,
  APIConnectionService,
  ContactInquiryService,
  ChangeProposalService,
} from "@palman/api";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Create service instances
export const authService = new AuthService(supabase);
export const projectService = new ProjectService(supabase);
export const documentService = new DocumentService(supabase);
export const notionService = new NotionService(supabase);
export const userService = new UserService(supabase);
export const roomService = new RoomService(supabase);
export const chatService = new ChatService(supabaseUrl, supabaseAnonKey);
export const slackService = new SlackService(supabase);
export const discordService = new DiscordService(supabase);
export const projectSettingsService = new ProjectSettingsService(supabase);
export const mcpConnectionService = new MCPConnectionService(supabase);
export const apiConnectionService = new APIConnectionService(supabase);
export const contactInquiryService = new ContactInquiryService(supabase);
export const changeProposalService = new ChangeProposalService(supabase);
